export default __webpack_public_path__ + "static/media/2410272.9bc230c4.webp";